const masterRoleKey = 'superadmin';
const uncategorizedKey = 'backend';
const systemRoles = ['superadmin', 'admin', 'ai-admin', 'manager', 'agent', 'viewer'];

const uncategorizedCategory = {
  label: 'Backend(*superadmin)',
  index: Infinity,
  superadmin: true,
};

export {
  masterRoleKey,
  uncategorizedKey,
  uncategorizedCategory,
  systemRoles,
};
